// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FullscreenOverlay__wrapper___Lgsvs"};